import { Route } from '@angular/router';
import { userFeature, usersEffects } from '@ls-commons/users/store';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { UserListComponent } from './lib/user-list/user-list.component';

export const userRoutes: Route[] = [
  {
    path: '',
    children: [{ path: '', component: UserListComponent, title: '' }],
    providers: [provideState(userFeature), provideEffects(usersEffects)],
  },
];
